export const handleSearchParams =  (data) => {
	return data.toString();
};
